import styled from "styled-components";
import { remCalc } from "../../../theme/style-utils-coras-nua";
import defaultTheme from "../../../theme/theme-test-override";

const BaseChoiceStyle = styled("div")`
    order: 3;
    position: relative;
    .field-label {
        font-weight: ${props => props.theme.fontWeights.regular};
        font-size: ${remCalc(16)};
        line-height: ${remCalc(22)};
        margin-bottom: ${remCalc(10)};
    }
    ${"" /* Visually removing actual input from UI: */}
    input {
        position: absolute;
        width: ${remCalc(1)};
        height: ${remCalc(1)};
        left: ${remCalc(1)};
        top: ${remCalc(1)};
        opacity: 0;
    }
`;

BaseChoiceStyle.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

export default BaseChoiceStyle;
